import BaseStore from '@/store';
import actions from './tripSearch.actions.js';
import getters from './tripSearch.getters.js';
import mutations from './tripSearch.mutations.js';
import state from './tripSearch.state.js';
let store = {
	namespaced: true,
	state,
	actions,
	getters,
	mutations,
};

export default store;

export function tryRegisterStoreDynamically(id) {
	let path = `tripSearch/${  id  }/`;

	if (path in BaseStore._modulesNamespaceMap) {
		return false;
	}

	BaseStore.registerModule(path.slice(0, -1), store);
	return true;
}
